import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration - viewer-web app
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDROZO7SN3HWT7nP__1V3MxHjm5FmtXMr0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "cviss-waypoint-control.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "cviss-waypoint-control",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "cviss-waypoint-control.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "782370927593",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:782370927593:web:3261ae649f50b257661178",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-WPQBQSXMXN"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

export default app;